import { backupApi } from '../api/backupApi'

export const getBackupFiles = async () => {
  try {
    const response = await backupApi.getBackupFiles()
    return response.data
  } catch (error) {
    console.error(`Error fetching backup files: `, error)
    throw error
  }
}
